(function ($) {
    'use strict';

    $(document).ready(function () {
        // Track the button that triggered the modal
        let $triggeringBtn = null;

        $(document).on('click', '.product-like-action', function (e) {
            e.preventDefault();
            const $btn = $(this);
            const productId = $btn.data('product-id');
            const listId = $btn.attr('data-list-id') || '';

            if ($btn.hasClass('require-login')) {
                const accountWidget = document.querySelector(".header-account");
                const isPopupEnabled = accountWidget && accountWidget.classList.contains("pop-up-login");
                if (isPopupEnabled) {
                    const modalEl = document.getElementById("login-popup-modal");
                    if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        bootstrap.Modal.getOrCreateInstance(modalEl).show();
                    } else {
                        alert(NS_Like_Shortcode.messages.login_required);
                    }
                } else {
                    const accountLink = document.querySelector(".header-account .box-inner");
                    window.location.href = accountLink ? accountLink.getAttribute("href") : "/my-account/";
                }
                return;
            }

            if ($btn.hasClass('disabled')) {
                return;
            }

            // If a specific list ID is provided, toggle directly (e.g., from favorites page trash icon)
            if (listId !== '') {
                $btn.addClass('disabled');
                $.ajax({
                    url: NS_Like_Shortcode.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'negarshop_like_toggle',
                        product_id: productId,
                        list_id: listId,
                        nonce: NS_Like_Shortcode.nonce
                    },
                    success: function (response) {
                        if (response.success) {
                            const reload = $btn.data('reload');
                            if (reload === true || reload === 'true' || reload === 1 || reload === '1') {
                                location.reload();
                                return;
                            }

                            const likeIcon = $btn.data('like-icon');
                            const likeLabel = $btn.data('like-label');
                            const dislikeIcon = $btn.data('dislike-icon');
                            const dislikeLabel = $btn.data('dislike-label');

                            if (response.action === 'added') {
                                $btn.addClass('liked');
                                if (dislikeIcon) {
                                    $btn.find('.button-icon i').attr('class', dislikeIcon);
                                }
                                if (dislikeLabel) {
                                    $btn.find('.button-text').text(dislikeLabel);
                                }
                            } else {
                                $btn.removeClass('liked');
                                if (likeIcon) {
                                    $btn.find('.button-icon i').attr('class', likeIcon);
                                }
                                if (likeLabel) {
                                    $btn.find('.button-text').text(likeLabel);
                                }
                            }
                        } else {
                            alert(response.message || NS_Like_Shortcode.messages.error);
                        }
                    },
                    error: function () {
                        alert(NS_Like_Shortcode.messages.error);
                    },
                    complete: function () {
                        $btn.removeClass('disabled');
                    }
                });
                return;
            }

            // Otherwise, open the modal to choose lists
            const modalEl = document.getElementById("negarshop-fav-lists-modal");
            if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                $triggeringBtn = $btn;
                const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
                
                // Show loading spinner first
                $('#negarshop-fav-lists-modal-body').html(
                    '<div class="text-center py-4"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">در حال بارگذاری...</span></div></div>'
                );
                modal.show();

                // Fetch content
                $.ajax({
                    url: NS_Like_Shortcode.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'negarshop_fav_get_modal_content',
                        product_id: productId,
                        nonce: NS_Like_Shortcode.nonce
                    },
                    success: function (response) {
                        if (response.success) {
                            $('#negarshop-fav-lists-modal-body').html(response.html);
                        } else {
                            $('#negarshop-fav-lists-modal-body').html(
                                '<div class="alert alert-danger mb-0">' + (response.message || NS_Like_Shortcode.messages.error) + '</div>'
                            );
                        }
                    },
                    error: function () {
                        $('#negarshop-fav-lists-modal-body').html(
                            '<div class="alert alert-danger mb-0">' + NS_Like_Shortcode.messages.error + '</div>'
                        );
                    }
                });
            } else {
                // Fallback to simple default toggle if modal element is not present
                $btn.addClass('disabled');
                $.ajax({
                    url: NS_Like_Shortcode.ajax_url,
                    type: 'POST',
                    data: {
                        action: 'negarshop_like_toggle',
                        product_id: productId,
                        nonce: NS_Like_Shortcode.nonce
                    },
                    success: function (response) {
                        if (response.success) {
                            const reload = $btn.data('reload');
                            if (reload === true || reload === 'true' || reload === 1 || reload === '1') {
                                location.reload();
                                return;
                            }

                            if (response.action === 'added') {
                                $btn.addClass('liked');
                            } else {
                                $btn.removeClass('liked');
                            }
                        } else {
                            alert(response.message || NS_Like_Shortcode.messages.error);
                        }
                    },
                    error: function () {
                        alert(NS_Like_Shortcode.messages.error);
                    },
                    complete: function () {
                        $btn.removeClass('disabled');
                    }
                });
            }
        });

        // Handle creating a new list inside the modal
        $(document).on('click', '#ns-fav-create-list-btn', function (e) {
            e.preventDefault();
            const $nameInput = $('#ns-fav-new-list-name');
            const listName = $nameInput.val().trim();
            const $errorDiv = $('#ns-fav-new-list-error');

            if (!listName) {
                $errorDiv.text('لطفا نام لیست را وارد کنید.').removeClass('d-none');
                return;
            }

            $errorDiv.addClass('d-none');
            const $btn = $(this);
            $btn.prop('disabled', true);

            $.ajax({
                url: NS_Like_Shortcode.ajax_url,
                type: 'POST',
                data: {
                    action: 'negarshop_fav_create_list',
                    list_name: listName,
                    nonce: NS_Like_Shortcode.nonce
                },
                success: function (response) {
                    if (response.success) {
                        $nameInput.val('');
                        // Add the new list option to the checkboxes
                        const checkboxHtml = `
                            <div class="form-check d-flex align-items-center justify-content-between p-2 mb-2 rounded border border-light bg-light-subtle hover-shadow transition-all" style="cursor: pointer;">
                                <label class="form-check-label w-100 pr-2 cursor-pointer d-flex align-items-center justify-content-between" for="ns-fav-list-chk-${response.list_id}">
                                    <span class="d-flex align-items-center">
                                        <input class="form-check-input ms-2 me-0" type="checkbox" name="list_ids[]" value="${response.list_id}" id="ns-fav-list-chk-${response.list_id}" checked>
                                        <span class="fs-7 font-weight-medium text-dark" style="margin-right: 8px;">${response.list_name}</span>
                                    </span>
                                </label>
                            </div>
                        `;
                        $('.ns-fav-lists-checkboxes').append(checkboxHtml);
                    } else {
                        $errorDiv.text(response.message || 'خطایی رخ داد.').removeClass('d-none');
                    }
                },
                error: function () {
                    $errorDiv.text('خطایی رخ داد.').removeClass('d-none');
                },
                complete: function () {
                    $btn.prop('disabled', false);
                }
            });
        });

        // Handle saving list changes
        $(document).on('submit', '#ns-fav-lists-form', function (e) {
            e.preventDefault();
            const $form = $(this);
            const $saveBtn = $('#ns-fav-save-btn');
            $saveBtn.prop('disabled', true).text('در حال ذخیره...');

            $.ajax({
                url: NS_Like_Shortcode.ajax_url,
                type: 'POST',
                data: $form.serialize() + '&action=negarshop_fav_save_product_lists&nonce=' + NS_Like_Shortcode.nonce,
                success: function (response) {
                    if (response.success) {
                        const modalEl = document.getElementById("negarshop-fav-lists-modal");
                        if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                            const modalInstance = bootstrap.Modal.getInstance(modalEl);
                            if (modalInstance) {
                                modalInstance.hide();
                            }
                        }
                        
                        // Update triggering button class if needed
                        if ($triggeringBtn) {
                            const reload = $triggeringBtn.data('reload');
                            if (reload === true || reload === 'true' || reload === 1 || reload === '1') {
                                location.reload();
                                return;
                            }

                            const likeIcon = $triggeringBtn.data('like-icon');
                            const likeLabel = $triggeringBtn.data('like-label');
                            const dislikeIcon = $triggeringBtn.data('dislike-icon');
                            const dislikeLabel = $triggeringBtn.data('dislike-label');

                            if (response.in_any_list) {
                                $triggeringBtn.addClass('liked');
                                if (dislikeIcon) {
                                    $triggeringBtn.find('.button-icon i').attr('class', dislikeIcon);
                                }
                                if (dislikeLabel) {
                                    $triggeringBtn.find('.button-text').text(dislikeLabel);
                                }
                            } else {
                                $triggeringBtn.removeClass('liked');
                                if (likeIcon) {
                                    $triggeringBtn.find('.button-icon i').attr('class', likeIcon);
                                }
                                if (likeLabel) {
                                    $triggeringBtn.find('.button-text').text(likeLabel);
                                }
                            }
                        }
                    } else {
                        alert(response.message || 'خطایی رخ داد.');
                    }
                },
                error: function () {
                    alert('خطایی رخ داد.');
                },
                complete: function () {
                    $saveBtn.prop('disabled', false).text('ذخیره تغییرات');
                }
            });
        });

        // Handle list creation from the Favorites account page modal
        $(document).on('submit', '#ns-fav-page-create-list-form', function (e) {
            e.preventDefault();
            const $nameInput = $('#ns-fav-page-new-list-name');
            const listName = $nameInput.val().trim();
            const $errorDiv = $('#ns-fav-page-new-list-error');

            if (!listName) {
                $errorDiv.text('لطفا نام لیست را وارد کنید.').removeClass('d-none');
                return;
            }

            $errorDiv.addClass('d-none');
            const $btn = $('#ns-fav-page-create-submit-btn');
            $btn.prop('disabled', true).text('در حال ایجاد...');

            $.ajax({
                url: NS_Like_Shortcode.ajax_url,
                type: 'POST',
                data: {
                    action: 'negarshop_fav_create_list',
                    list_name: listName,
                    nonce: NS_Like_Shortcode.nonce
                },
                success: function (response) {
                    if (response.success) {
                        // Hide modal
                        const modalEl = document.getElementById("ns-fav-create-list-modal");
                        if (modalEl && typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                            const modalInstance = bootstrap.Modal.getInstance(modalEl);
                            if (modalInstance) {
                                modalInstance.hide();
                            }
                        }
                        // Redirect to the newly created list
                        const url = new URL(window.location.href);
                        url.searchParams.set('list_id', response.list_id);
                        window.location.href = url.toString();
                    } else {
                        $errorDiv.text(response.message || 'خطایی رخ داد.').removeClass('d-none');
                        $btn.prop('disabled', false).text('ایجاد لیست');
                    }
                },
                error: function () {
                    $errorDiv.text('خطایی رخ داد.').removeClass('d-none');
                    $btn.prop('disabled', false).text('ایجاد لیست');
                }
            });
        });

        // Handle list deletion from the Favorites account page
        $(document).on('click', '.ns-fav-page-delete-list-btn', function (e) {
            e.preventDefault();
            const listId = $(this).data('list-id');
            if (!listId || listId === 'default') {
                return;
            }

            if (!confirm('آیا از حذف این لیست اطمینان دارید؟ تمامی محصولات این لیست از علاقه‌مندی‌های این لیست حذف خواهند شد.')) {
                return;
            }

            const $btn = $(this);
            $btn.prop('disabled', true);

            $.ajax({
                url: NS_Like_Shortcode.ajax_url,
                type: 'POST',
                data: {
                    action: 'negarshop_fav_delete_list',
                    list_id: listId,
                    nonce: NS_Like_Shortcode.nonce
                },
                success: function (response) {
                    if (response.success) {
                        // Redirect back to default list
                        const url = new URL(window.location.href);
                        url.searchParams.set('list_id', 'default');
                        window.location.href = url.toString();
                    } else {
                        alert(response.message || 'خطایی رخ داد.');
                        $btn.prop('disabled', false);
                    }
                },
                error: function () {
                    alert('خطایی رخ داد.');
                    $btn.prop('disabled', false);
                }
            });
        });
    });
})(jQuery);
